import type { ExtensionHandlerProps } from '@confluence/fabric-extension-lib/entry-points/commonExtensionTypes.ts';
import type { LoadableType } from '@confluence/loadable';
import { LoadableAfterPaint } from '@confluence/loadable';

// M10: the macro's after-paint boundary now loads `QuestionsMacroRoot`, the experiment selector that
// mounts either the Apollo control (`GlobalQuestionsListMacroHandler`) or the native Relay treatment
// (`RelayGlobalQuestionsListMacroHandler`). The chunk name is preserved so code-splitting for the
// editor macro is unchanged; only the module that owns the Apollo-vs-Relay decision moved behind the
// boundary. See `src/QuestionsMacroRoot.tsx`.
export const GlobalQuestionsListMacroHandler: LoadableType<{
	macroDefaultProps: ExtensionHandlerProps;
	macroParams: any;
}> = LoadableAfterPaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-GlobalQuestionsListMacroHandler" */ '../src/QuestionsMacroRoot.tsx'
			)
		).QuestionsMacroRoot,
});
